import { render, staticRenderFns } from "./ActualizarReglaPLDP.vue?vue&type=template&id=74e19556"
import script from "./ActualizarReglaPLDP.vue?vue&type=script&lang=js"
export * from "./ActualizarReglaPLDP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports